import 'leaflet'
import BasePopup from './BasePopup'
import Vue from 'vue'
import VueMapPopupInfo from '../../../components/map-popup/map-popup-car'

const MapPopupCar = BasePopup.extend({
  getVueComponent: function () {
    return new Vue(VueMapPopupInfo)
  },
})

export default MapPopupCar
